import { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import ImageUploader from "@/components/ImageUploader";

// Team-manager card to upload / replace the club's official team photograph
export const TeamPhotoCard = ({ team, onSaved }) => {
  const [url, setUrl] = useState(team.team_photo_url || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const res = await axios.put(`${API}/manager/my-team/photo`, { team_photo_url: url }, { withCredentials: true });
      onSaved(res.data);
      toast.success("Team photo updated — it now appears on your public team page");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save team photo");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white p-6 border border-gray-200 mb-8" data-testid="team-photo-card">
      <h3 className="font-heading font-bold text-lg uppercase text-[#09090b] mb-1 flex items-center gap-2">
        <Camera className="w-5 h-5 text-[#009E60]" /> Team Photo
      </h3>
      <p className="text-sm text-gray-500 mb-4">Shown as the banner on your club's public profile. Use an official squad photo.</p>
      <ImageUploader value={url} onChange={setUrl} category="team-photo" label="Team Photograph" previewShape="wide" testId="manager-team-photo" />
      <Button onClick={save} disabled={saving || url === (team.team_photo_url || "")} className="mt-4 bg-[#FFC72C] hover:bg-[#E6B325] text-black rounded-none" data-testid="save-team-photo-btn">
        {saving ? "Saving..." : "Save Team Photo"}
      </Button>
    </div>
  );
};
